import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { IndicadoresPgAtividadeSituacaoService } from "../services/indicadores-pg-atividade-situacao.service";

@Injectable({
  providedIn: 'root'
})
export class IndicadoresPgAtividadeSituacaoListResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresPgAtividadeSituacaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdListEdit(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class IndicadoresPgAtividadeSituacaoResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresPgAtividadeSituacaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}